import React from 'react';
import 'CSS/demand-supply/demand-supply.scss';
import 'CSS/dashboard-statistic.scss';
import 'CSS/dashboard-tickets.scss';
import 'CSS/dashboard-slips.scss';
import Grid from '@material-ui/core/Grid';

export const Url = props => {
  return (
    <Grid container className=" u-pad-top-10 u-pad-bot-10">
      <h2 className="t-primary-16 t-weight-b u-mrg-bot-10 u-mrg-top-10">URL</h2>
      <Grid container className="t-primary-14 c-gray-light">
        <Grid item xs={12} className="">
          <a
            href={props.url}
            target="_blank"
            rel="noopener noreferrer"
            className="t-dec-none"
          >
            {props.url}
          </a>
        </Grid>
      </Grid>
    </Grid>
  );
};
